(function () {
  var TRACK_SELECTOR = '.kk-related-vertical-carousel__track';
  var SLIDE_SELECTOR = '.kk-related-slide';
  var INIT_ATTR = 'data-kk-auto-scroll-initialized';
  var AUTO_SCROLL_INTERVAL_MS = 3200;
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function getSlides(track) {
    return Array.prototype.slice.call(track.querySelectorAll(SLIDE_SELECTOR));
  }

  function getClosestSlideIndex(track, slides) {
    var scrollTop = track.scrollTop;
    var closestIndex = 0;
    var closestDistance = Number.POSITIVE_INFINITY;

    slides.forEach(function (slide, index) {
      var distance = Math.abs(slide.offsetTop - scrollTop);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  function initAutoScroll(track) {
    if (!track || track.hasAttribute(INIT_ATTR) || reducedMotionQuery.matches) return;

    var slides = getSlides(track);
    if (slides.length < 2) return;

    track.setAttribute(INIT_ATTR, 'true');

    var currentIndex = getClosestSlideIndex(track, slides);
    var timerId = null;
    var rafId = null;
    var isInView = false;
    var isPaused = false;
    var scrollTimeout = null;
    var isProgrammaticScroll = false;

    function getTrackViewportCenter() {
      // Get the position of the carousel track in the viewport
      var rect = track.getBoundingClientRect();
      if (!rect) return null;
      var trackViewportTop = rect.top;
      var trackViewportHeight = rect.height;
      // Center point of the carousel in the viewport
      return trackViewportTop + trackViewportHeight / 2;
    }

    function snapToCenter() {
      var currentSlides = getSlides(track);
      if (!currentSlides.length) return;
      
      var viewportCenter = getTrackViewportCenter();
      if (viewportCenter === null) return;
      
      var closestIndex = 0;
      var closestDistance = Number.POSITIVE_INFINITY;
      
      // Find which slide is closest to the viewport center
      currentSlides.forEach(function (slide, index) {
        var slideRect = slide.getBoundingClientRect();
        if (!slideRect) return;
        var slideCenterInViewport = slideRect.top + slideRect.height / 2;
        var distance = Math.abs(slideCenterInViewport - viewportCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      
      // Snap to the closest slide
      currentIndex = closestIndex;
      isProgrammaticScroll = true;
      track.scrollTo({
        top: currentSlides[closestIndex].offsetTop,
        behavior: 'smooth',
      });
      setTimeout(function () {
        isProgrammaticScroll = false;
      }, 50);
    }

    function scrollToCurrent(behavior) {
      var currentSlides = getSlides(track);
      if (!currentSlides.length) return;
      if (currentIndex >= currentSlides.length) currentIndex = 0;
      isProgrammaticScroll = true;
      track.scrollTo({
        top: currentSlides[currentIndex].offsetTop,
        behavior: behavior || 'smooth',
      });
      // Reset the flag after a brief delay to account for scroll event timing
      setTimeout(function () {
        isProgrammaticScroll = false;
      }, 50);
    }

    function stop() {
      if (timerId === null) return;
      window.clearInterval(timerId);
      timerId = null;
    }

    function resetAutoScrollTimer() {
      if (scrollTimeout) window.clearTimeout(scrollTimeout);
      scrollTimeout = window.setTimeout(function () {
        if (!isPaused && isInView && !reducedMotionQuery.matches) {
          start();
        }
      }, 800);
    }

    function start() {
      if (timerId !== null || isPaused || !isInView || reducedMotionQuery.matches) return;
      timerId = window.setInterval(function () {
        var currentSlides = getSlides(track);
        if (currentSlides.length < 2) {
          stop();
          return;
        }
        currentIndex = (currentIndex + 1) % currentSlides.length;
        scrollToCurrent('smooth');
      }, AUTO_SCROLL_INTERVAL_MS);
    }

    function syncIndexToScroll() {
      // Only pause if this is a user-initiated scroll, not a programmatic one
      if (isProgrammaticScroll) return;
      
      if (rafId) return;
      rafId = window.requestAnimationFrame(function () {
        rafId = null;
        var currentSlides = getSlides(track);
        if (!currentSlides.length) return;
        currentIndex = getClosestSlideIndex(track, currentSlides);
      });
      stop();
      resetAutoScrollTimer();
    }

    function setPaused(nextPaused) {
      isPaused = nextPaused;
      if (isPaused) {
        stop();
      } else {
        start();
      }
    }

    var visibilityObserver = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        if (!entry) return;
        isInView = entry.isIntersecting && entry.intersectionRatio >= 0.25;
        if (isInView) {
          start();
        } else {
          stop();
        }
      },
      { threshold: [0.25] }
    );

    visibilityObserver.observe(track);

    // Allow programmatic scroll only
    track.addEventListener('scroll', syncIndexToScroll, { passive: true });

    // Snap to center when carousel is in focus (centered in viewport) or when user scrolls page
    var pageScrollTimeout = null;
    var lastPageScrollTime = 0;

    function handlePageScroll() {
      var now = Date.now();
      lastPageScrollTime = now;
      
      if (pageScrollTimeout) window.clearTimeout(pageScrollTimeout);
      pageScrollTimeout = window.setTimeout(function () {
        // After user stops scrolling for 400ms, snap to center if carousel is in view
        if (isInView) {
          snapToCenter();
        }
      }, 400);
    }

    window.addEventListener('scroll', handlePageScroll, { passive: true });

    if (typeof reducedMotionQuery.addEventListener === 'function') {
      reducedMotionQuery.addEventListener('change', function (event) {
        if (event.matches) {
          stop();
        } else {
          start();
        }
      });
    } else if (typeof reducedMotionQuery.addListener === 'function') {
      reducedMotionQuery.addListener(function (event) {
        if (event.matches) {
          stop();
        } else {
          start();
        }
      });
    }
  }

  function fitTrackToSlide(track) {
    if (!track) return;
    var slides = getSlides(track);
    if (!slides.length) return;

    var tallest = 0;
    slides.forEach(function (slide) {
      tallest = Math.max(tallest, slide.offsetHeight);
    });
    if (tallest > 0) track.style.maxHeight = tallest + 'px';
  }

  function fitAllTracks() {
    document.querySelectorAll(TRACK_SELECTOR).forEach(fitTrackToSlide);
  }

  var resizeTimer = null;
  window.addEventListener(
    'resize',
    function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(fitAllTracks, 150);
    },
    { passive: true }
  );

  function initInRoot(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(TRACK_SELECTOR).forEach(function (track) {
      // Hoyden settes for autoscrollingen, og uavhengig av den: initAutoScroll
      // hopper ut ved redusert bevegelse og ved faerre enn to kort, men et
      // kuttet kort er like galt der.
      fitTrackToSlide(track);
      initAutoScroll(track);
    });
  }

  function observeDomForNewCarousels() {
    var domObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches(TRACK_SELECTOR)) {
            initAutoScroll(node);
          }
          initInRoot(node);
        });
      });
    });

    domObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initInRoot(document);
      observeDomForNewCarousels();
    });
  } else {
    initInRoot(document);
    observeDomForNewCarousels();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      initInRoot(event.target);
    });
  }
})();
